import gql from 'graphql-tag'

export default gql`mutation updateUserRole($data: UserRoleInput) {
    updateUserRole(data: $data) @client
}`